import { useState } from "react";
import { BRAND } from "@/config/brand";

const SIZES = { sm: "h-11", md: "h-20", lg: "h-32 sm:h-40", xl: "h-48 xl:h-56" };

// Official logo, rendered as-is (object-contain keeps proportions). Text fallback only if the file fails to load.
export const Logo = ({ size = "md", className = "", testId = "brand-logo" }) => {
  const [failed, setFailed] = useState(false);
  if (failed) {
    return (
      <span data-testid={`${testId}-fallback`} className={`font-display font-extrabold tracking-tight text-[#000B45] ${className}`}>
        {BRAND.name}
      </span>
    );
  }
  return (
    <img
      src={BRAND.logoSrc}
      alt={BRAND.name}
      data-testid={testId}
      onError={() => setFailed(true)}
      className={`${SIZES[size]} aspect-[3/2] w-auto rounded-md object-contain select-none ${className}`}
      draggable={false}
    />
  );
};
